import React from "react";
import PropTypes from "prop-types";

const PadlockSmoothIcon = ({
  noPointer,
  className,
  width,
  size,
  height,
  style,
  color
}) => (
  <svg
    className={className}
    style={style}
    data-no-pointer={noPointer}
    width={width || size || 24}
    height={height || size || 24}
    viewBox="0 0 14 16"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="title"
  >
    <g fill="none" fillRule="evenodd">
      <path d="M.8.8h16v16H.8z" />
      <g transform="translate(1.9 .9)">
        <path d="M.9 3.9h12v12H.9z" />
        <path
          d="M2.9 7.8a1.1 1.1 0 0 0-1.1 1.1v4A1.1 1.1 0 0 0 2.9 14h8a1.1 1.1 0 0 0 1.1-1.1v-4a1.1 1.1 0 0 0-1.1-1.1h-8zm0-1.8h8a2.9 2.9 0 0 1 2.9 2.9v4a2.9 2.9 0 0 1-2.9 2.9h-8A2.9 2.9 0 0 1 0 12.9v-4A2.9 2.9 0 0 1 2.9 6z"
          fill="#2C2E2F"
        />
        <path
          d="M9 3.9a2.1 2.1 0 0 0-4.2 0V6H9V3.9zM6.9 0a3.9 3.9 0 0 1 3.9 3.9v3.9H3V3.9A3.9 3.9 0 0 1 6.9 0z"
          fill="#2C2E2F"
        />
        <circle fill="#2C2E2F" cx="6.9" cy="10.9" r="1" />
      </g>
    </g>
  </svg>
);
PadlockSmoothIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  size: PropTypes.string,
  height: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.string
};

export default PadlockSmoothIcon;
